import { CART_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };
export interface ICartDelete {
  cart_id: string;
  reason: string;
}
export const useCartDeleteAPI = () => {
  const configuration = useConfiguration();

  const dispatch = useAppDispatch();
  const { captureError, toastNotification } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (deletePayload: ICartDelete) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .post(`${CART_MODULE?.DELETE_CART_API?.baseURL}`, deletePayload, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              toastNotification(res.data.message);
              return { status: true, message: "Delete Success" };
            } else {
              captureError(res.data.message);
              return { status: false, message: "Delete Unsuccessfull" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: "cart_not_filtered" };
          });
        return response;
      } catch (e) {
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
